import React from "react";
import { Button, Form, Select } from "antd";
import { PaymentChannel } from "./types";
import { formatCcRate } from "./usePaymentAmounts";

export const PAYMENT_CHANNELS: PaymentChannel[] = [
  { id: 1, value: "dobw",          logo: "duitnow.png",  label: "Online Banking/Wallets", bankName: "dobw_banklist", fieldLabel: "Bank" },
  { id: 2, value: "public_bank_2", logo: "master.png",   label: "Credit/Debit Card",      bankName: "pbb_banklist",  fieldLabel: "Card Method" },
  { id: 3, value: "fpx_b2c",       logo: "fpx-new.png",  label: "B2C (Retail Banking)",   bankName: "banklist",      fieldLabel: "Bank" },
];

export default function PaymentMethodPanel(
  props: {
    paymentInfo: any;
    selectedChannel: PaymentChannel | null;
    onSelectChannel: (channel: PaymentChannel) => void;
    paymentMethodOptions: any[];
    ccRate: number;
    showAdminFee: boolean;
  }
) {
  const { paymentInfo, selectedChannel, onSelectChannel, paymentMethodOptions, ccRate, showAdminFee } = props;

  const isAvailable = (channel: PaymentChannel) =>
    channel.value === "dobw"    ? paymentInfo.dobw_available :
    channel.value === "fpx_b2c" ? paymentInfo.fpxb2c_available :
    true;

  return (
    <div className="b2c2b-section_panel" style={{ marginBottom: 24, overflow: "hidden" }}>
      <div className="b2c2b-section_panel-header">
        <label>Select payment method</label>
      </div>
      <div className="payment-gateway_channels">
        {PAYMENT_CHANNELS.map((channel) => {
          const available = isAvailable(channel);
          return (
            <Button
              key={channel.id}
              type="default"
              variant="outlined"
              disabled={!available}
              onClick={() => available && onSelectChannel(channel)}
              className={`payment-gateway_channels-box ${selectedChannel?.value === channel.value ? "selected" : ""}`}
            >
              <img src={`/iceholidays-assets/images/payment/${channel.logo}`} alt={channel.label} />
              <span>{channel.label}</span>
            </Button>
          );
        })}
      </div>

      {paymentMethodOptions.length > 0 && (
        <Form.Item
          label={selectedChannel?.fieldLabel}
          name="payment_method"
          rules={[{ required: true }]}
          style={{ padding: "0 20px", marginTop: 16 }}
        >
          <Select options={paymentMethodOptions} placeholder="Select..." />
        </Form.Item>
      )}

      {showAdminFee && (
        <p style={{ padding: "0 20px", color: "#888", fontSize: 13 }}>
          A service fee of {formatCcRate(ccRate)} applies for credit/debit card payments.
        </p>
      )}
      <div style={{ height: 20 }} />
    </div>
  );
}
